// Free Sticker text
const freeStickerText = 'Spotlight stickers are non-refundable digital merchandise, delivered immediately. '
  + 'Originators grant a <strong>non-exclusive, royalty-free license for in-app use only</strong>. '
  + 'Stickers are collectibles for display on your Spotlight profile and sticker wall, and cannot be '
  + 'transferred, resold, or used outside the app.<br/><br/>'
  + 'Your name, email, and purchase amount will be shared with the Sticker Owner. By continuing, you agree '
  + 'to our <a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">'
  + 'Terms & Conditions</a> and <a href="https://www.spotlight.xyz/legal-stuff/privacy-policy" '
  + 'target="_blank">Privacy Policy</a>.';

// Paid Sticker text
const paidStickerText = 'Spotlight stickers are non-refundable digital merchandise, delivered immediately. '
  + 'Originators grant a <strong>non-exclusive, royalty-free license for in-app use only</strong>. '
  + 'Stickers are collectibles for display on your Spotlight profile and sticker wall, and cannot be '
  + 'transferred, resold, or used outside the app.<br/><br/>'
  + 'Your name, email, and purchase amount will be shared with the Sticker Owner. By continuing, you agree '
  + 'to our <a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">'
  + 'Terms & Conditions</a> and <a href="https://www.spotlight.xyz/legal-stuff/privacy-policy" '
  + 'target="_blank">Privacy Policy</a>.';

// Ticket Sticker text
const ticketStickerText = 'Spotlight ticket stickers are digital collectibles that also serve as your '
  + 'entry pass to this event. All stickers are non-refundable and delivered immediately. Originators '
  + 'grant a <strong>non-exclusive, royalty-free license for in-app use only</strong>. Stickers are '
  + 'collectibles for display on your Spotlight profile and sticker wall, and cannot be transferred, '
  + 'resold, or used outside the app.<br/><br/>'
  + 'If you add a donation at checkout, your donation is processed by the <strong>American Online '
  + 'Giving Fund (AOGF)</strong>, a U.S. 501(c)(3) donor-advised fund (EIN: 81-0739440). You may '
  + 'recommend that your donation be granted to a specific nonprofit through the Spotlight app. AOGF '
  + 'disburses donations monthly to eligible charities. Donations are final and non-refundable. Only '
  + 'the donation portion is tax-deductible; fees are not deductible. '
  + '<a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">Learn more</a>'
  + '<br/><br/>Tickets are subject to event venue rules and may require presentation of your digital '
  + 'sticker at entry.<br/><br/>'
  + 'By continuing, you agree to Spotlight\'s '
  + '<a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">'
  + 'Terms & Conditions</a> and <a href="https://www.spotlight.xyz/legal-stuff/privacy-policy" '
  + 'target="_blank">Privacy Policy</a>. Your name, email, and purchase/donation amount will be shared '
  + 'with the sticker creator.';

// V2 Campaign text
const v2CampaignText = 'Your donation is processed by the <strong>American Online Giving Fund (AOGF)</strong>, '
  + 'a U.S. 501(c)(3) donor-advised fund (EIN: 81-0739440). You may recommend that your donation be '
  + 'granted to a specific nonprofit through the Spotlight app. AOGF disburses donations monthly to '
  + 'eligible charities. Donations are final and non-refundable. Only the donation amount is '
  + 'tax-deductible; fees are not deductible. '
  + '<a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">Learn more</a>'
  + '<br/><br/>As a thank-you, you\'ll receive a <strong>Spotlight digital sticker</strong>. Stickers '
  + 'are non-refundable digital merchandise, delivered immediately. Originators grant a '
  + '<strong>non-exclusive, royalty-free license for in-app use only</strong>. Stickers are collectibles '
  + 'for display on your Spotlight profile and sticker wall, and cannot be transferred, resold, or used '
  + 'outside the app.<br/><br/>'
  + 'Your name, email, and donation amount will be shared with the campaign owner. By continuing, you '
  + 'agree to our <a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">'
  + 'Terms & Conditions</a> and <a href="https://www.spotlight.xyz/legal-stuff/privacy-policy" '
  + 'target="_blank">Privacy Policy</a>.';

// Sweepstakes text
const sweepstakesText = 'By getting this sweepstakes sticker, you will also receive an entry into the '
  + 'related sweepstakes promotion. <strong>No purchase necessary. Void where prohibited.</strong> '
  + 'Entry is subject to the <a href="https://www.spotlight.xyz/legal-stuff/sweepstakes-rules" '
  + 'target="_blank">Official Rules</a>, which include eligibility requirements and details on odds '
  + 'of winning.<br/><br/>'
  + 'Spotlight stickers are non-refundable digital merchandise, delivered immediately. Originators '
  + 'grant a <strong>non-exclusive, royalty-free license for in-app use only</strong>. Stickers are '
  + 'collectibles for display on your Spotlight profile and sticker wall, and cannot be transferred, '
  + 'resold, or used outside the app.<br/><br/>'
  + 'Sweepstakes entries are final and may be voided if entry rules are not followed.<br/><br/>'
  + 'Your name, email, and entry details will be shared with the campaign owner. By continuing, you '
  + 'agree to Spotlight\'s <a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" '
  + 'target="_blank">Terms & Conditions</a>, <a href="https://www.spotlight.xyz/legal-stuff/privacy-policy" '
  + 'target="_blank">Privacy Policy</a>, and the '
  + '<a href="https://www.spotlight.xyz/legal-stuff/sweepstakes-rules" target="_blank">'
  + 'Official Sweepstakes Rules</a>.';

// Wallet deposit text
const walletDepositText = 'Your deposit will be made to the American Online Giving Fund (AOGF), '
  + 'a U.S. 501(c)(3) donor-advised fund (EIN 81-0739440), which holds your Spotlight wallet. '
  + 'Funds added to your wallet are <strong>non-refundable</strong> and may only be used to '
  + 'support <strong>eligible</strong> charities through Spotlight\'s integration with the Benevity directory.<br/><br/>'
  + 'By continuing, you agree to our '
  + '<a href="https://www.spotlight.xyz/legal-stuff/terms-and-conditions" target="_blank">'
  + 'Terms & Conditions</a> and <a href="https://www.spotlight.xyz/legal-stuff/privacy-policy" '
  + 'target="_blank">Privacy Policy</a>.';

export {
  freeStickerText,
  paidStickerText,
  ticketStickerText,
  v2CampaignText,
  sweepstakesText,
  walletDepositText,
};
